import axios from 'axios'

async function delete_user_ass(data,setOpen,setMessage,setUsers,setDeleting){

try{

setDeleting(true)

const deleteUser = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}delete-user-ass/`,data,{
        headers:{
            "Content-Type":"application/json",
            "Authorization":`Bear ${data?.token}`
        }
    }).catch(err=>{console.log(err)})

if (deleteUser?.status == 200 && deleteUser?.data.success) {

    setUsers(deleteUser?.data?.users)
    setMessage("Participant has been deleted")
    setOpen(true)
    // console.log(deleteUser?.data?.test?.users)

}else{
    setMessage(deleteUser?.data.message)
    setOpen(true)
}
setDeleting(false)
}catch(err){
console.log(err)
}
}

export default delete_user_ass